import React from "react";
import {
  Nav,
  Loader,
  Card,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "ui-kit-ck-consultant";
import moment from "moment";

import FadeIn from "react-fade-in";

import AuthContext from "../../../context/AuthContext";
import ShowOptions from "../../../components/statistics/statistics-selfcare/ShowOptions";

import axiosConfig from "../../../utils/axiosConfig";
import { getValue } from "../../../utils/general";

export default class StatisticsHelvetia extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dateStart: moment().format("YYYY-01-01"),
      dateEnd: moment().format("YYYY-MM-DD"),
      network: 1,
      group: 1,
      region: 29,
      agency: 120,
    };
  }

  static contextType = AuthContext;

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      group: ["network"].includes(name) ? null : this.state.group,
      region: ["network", "group"].includes(name) ? null : this.state.region,
      agency: ["network", "group", "region"].includes(name)
        ? null
        : this.state.agency,
      [name]: value,
    });
  };

  componentDidMount() {
    if (this.context.companyId === 24) {
      this.setState({
        group: null,
        region: null,
        agency: null,
      });
    }
  }

  getData = () => {
    this.setState({ isLoad: true }, () => {
      axiosConfig({
        url: "pilotage-cabinet/company-performance/statistics-helvetia",
        data: {
          dateStart: this.state.dateStart,
          dateEnd: this.state.dateEnd,
          network: this.state.network,
          group: this.state.group,
          region: this.state.region,
          agency: this.state.agency,
        },
      })
        .then((res) => {
          if (res.data.success) {
            this.setState({
              data: res.data.data,
              isLoad: false,
            });
          } else {
            this.setState({
              data: null,
              isLoad: false,
            });
          }
        })
        .catch((e) => {
          console.log(e);

          this.setState({ isLoad: false }, () =>
            alert("Une erreur est survenue"),
          );
        });
    });
  };

  getTable = (title, data) => {
    return (
      <Card title={title} className={"mt-10"}>
        <Table>
          <Thead>
            <Tr>
              <Th></Th>
              <Th className="text-center">GLOBAL</Th>
              <Th colSpan={4} className="text-center">
                EAD
              </Th>
              <Th colSpan={4} className="text-center">
                VEHICULES REPARABLES
              </Th>
              <Th colSpan={2} className="text-center">
                VEHICULES IRREPARABLES
              </Th>
            </Tr>
            <Tr>
              <Th></Th>
              <Th>Volume total</Th>
              <Th>Volume</Th>
              <Th>Coût moyen HT</Th>
              <Th>Nb moyen heures de Main d'Œuvre (*1)</Th>
              <Th>Coût moyen HT Pièces</Th>
              <Th>Volume</Th>
              <Th>Coût moyen HT</Th>
              <Th>Nb moyen heures de Main d'Œuvre (*1)</Th>
              <Th>Coût moyen HT Pièces</Th>
              <Th>Volume</Th>
              <Th>VRADE HT moyenne</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Th>Résultats</Th>
              <Td>{getValue(data.count, 0)}</Td>
              <Td>{getValue(data.count_EAD, 0)}</Td>
              <Td>{getValue(data.averageCost_EAD)}</Td>
              <Td>{getValue(data.averageHour_EAD)}</Td>
              <Td>{getValue(data.averagePart_EAD)}</Td>
              <Td>{getValue(data.count_R, 0)}</Td>
              <Td>{getValue(data.averageCost_R)}</Td>
              <Td>{getValue(data.averageHour_R)}</Td>
              <Td>{getValue(data.averagePart_R)}</Td>
              <Td>{getValue(data.count_NR, 0)}</Td>
              <Td>{getValue(data.averageCost_NR)}</Td>
            </Tr>
            <Tr>
              <Th>Délais Moyen Dépôt Rapport</Th>
              <Td>{getValue(data.averageDelay)}</Td>
              <Td colSpan={4}>{getValue(data.averageDelay_EAD)}</Td>
              <Td colSpan={4}>{getValue(data.averageDelay_R)}</Td>
              <Td colSpan={2}>{getValue(data.averageDelay_NR)}</Td>
            </Tr>
            <Tr>
              <Th>Moyenne Honoraires HT</Th>
              <Td>{getValue(data.averageHonorary)}</Td>
              <Td colSpan={4}>{getValue(data.averageHonorary_EAD)}</Td>
              <Td colSpan={4}>{getValue(data.averageHonorary_R)}</Td>
              <Td colSpan={2}>{getValue(data.averageHonorary_NR)}</Td>
            </Tr>
          </Tbody>
        </Table>
      </Card>
    );
  };

  handleInputChange = (event) => {
    const { name, value } = event.target;

    let dateStart = this.state.dateStart;
    let dateEnd = this.state.dateEnd;

    if (
      name === "dateEnd" &&
      moment(value).format("YYYY") !== moment(dateStart).format("YYYY")
    ) {
      dateStart = moment(`${moment(value).format("YYYY")}-01-01`).format(
        "YYYY-MM-DD",
      );
    } else if (
      name === "dateStart" &&
      moment(value).format("YYYY") !== moment(dateEnd).format("YYYY")
    ) {
      dateEnd = moment(`${moment(value).format("YYYY")}-12-31`).format(
        "YYYY-MM-DD",
      );
    }

    this.setState({
      dateStart,
      dateEnd,
      [name]: value,
    });
  };

  handleInputBlur = () => {};

  handleSelectChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: Number(value) }, () => {
      if (name === "network") {
        this.setState({ group: 0, region: 0, agency: 0 });
      } else if (name === "group") {
        this.setState({ region: 0, agency: 0 });
      } else if (name === "region") {
        this.setState({ agency: 0 });
      }
    });
  };

  render() {
    if (this.context.id) {
      return (
        <>
          <FadeIn>
            <Nav title="Statistiques spécifiques" className="mb-20" />{" "}
            <ShowOptions
              className="mb-20"
              handleInputChange={this.handleInputChange}
              handleSelectChange={this.handleInputChange}
              getData={this.getData}
              isDateStart={true}
              isDateEnd={true}
              dateStart={this.state.dateStart}
              dateEnd={this.state.dateEnd}
              network={this.state.network}
              group={this.state.group}
              region={this.state.region}
              agency={this.state.agency}
              iskind
              defaultKind={this.state.kind}
            />
            {this.state.data ? (
              <>
                {this.getTable(
                  "VP CAMIONNETTES < 3,5t - DOSSIERS < À 15 000€ HT",
                  this.state.data.VP_15000_INF,
                )}
                {this.getTable(
                  "VP CAMIONNETTES < 3,5t - ANALYSE DOSSIERS >= à 15 000€ HT",

                  this.state.data.VP_15000_SUP,
                )}
                {this.getTable(
                  "P.L > 3,5t - DOSSIERS < À 15 000€ HT",
                  this.state.data.PL_15000_INF,
                )}
                {this.getTable(
                  "P.L > 3,5t - ANALYSE DOSSIERS >= à 15 000€ HT",
                  this.state.data.PL_15000_SUP,
                )}
              </>
            ) : null}
          </FadeIn>

          <Loader show={this.state.isLoad} />
        </>
      );
    } else {
      return <></>;
    }
  }
}
